// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getHome } from '../../apis/member';
import { IProduct } from '../actionCreators/home/getHomeActions';
import { RootAction, actionCreatorsList } from '../rootActionCreator';
import { RootState } from '../rootReducer';

const { getHomeActions } = actionCreatorsList;

const outputActions = {
  success: getHomeActions.success,
  failure: getHomeActions.failure
};

type RequestActionTypes = ActionType<typeof getHomeActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getHomeEpic = (
  action$: Observable<RootAction>,
  _state$?: Observable<RootState>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getHomeActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // send api promise
      return getHome()
        .then((response: AxiosResponse<IProduct[]>) => {
          // handle success case here
          return outputActions.success({
            list: response.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return outputActions.failure({ error: error.response?.data || 'Unhandled Error' });
        });
    })
  );
};
